import { USER_ROLE } from "lib/constants";
import { lazy } from "react";
import Distributor from "pages/dashboard/distributor/layout";
import Dashboard from "pages/dashboard/page";
import CreateCustomer from "pages/dashboard/customers/create/page";
import EditCustomer from "pages/dashboard/customers/[orgid]/edit/page";
import Sites from "pages/dashboard/customers/[orgid]/sites/page";
import CreateSite from "pages/dashboard/customers/[orgid]/sites/create/page";
import CreateDeviceSelect from "pages/dashboard/customers/[orgid]/sites/[siteid]/dev-select-page";
import Nvrs from "pages/dashboard/customers/[orgid]/sites/[siteid]/nvrs/page";
import CreateNvr from "pages/dashboard/customers/[orgid]/sites/[siteid]/nvrs/create/page";
import CreateEdgeCamera from "pages/dashboard/customers/[orgid]/sites/[siteid]/edgeCameras/create/page";
import Cameras from "pages/dashboard/customers/[orgid]/sites/[siteid]/nvrs/[nvrid]/cameras/page";
import CreateCamera from "pages/dashboard/customers/[orgid]/sites/[siteid]/nvrs/[nvrid]/cameras/create/page";
import IpSpeakers from "pages/dashboard/customers/[orgid]/sites/[siteid]/nvrs/[nvrid]/ip-speakers/page";
import Upload from "pages/dashboard/admin/upload/page";
import Upgrade from "pages/dashboard/admin/upgrade/page";
import CameraEdgeUpgrade from "pages/dashboard/admin/upgrade/camera_edge_page";
import AdminUser from "pages/dashboard/admin/user/page";
import AdminCamera from "pages/dashboard/admin/camera/page";
import DealerOrg from "pages/dashboard/dealer-org/page";
import SSO from "pages/dashboard/sso/page";
import ResetSendEmail from "pages/resetSendEmail";
import ResetActivate from "pages/resetActivate";
import VirtualGuardPage from "pages/dashboard/virtualGuard/page";
import VirtualGuardTemplate from "pages/dashboard/virtualGuardTemplate/page";
import VirtualGuardProgress from "pages/dashboard/virtualGuardProgress/page";
import Profile from "pages/dashboard/profile/page";
import OrganizationLayout from "pages/dashboard/organization/layout";
import DealerOrganizationLayout from "pages/dashboard/dealer-org/layout";
import Organization from "pages/dashboard/organization/page";
import CusomSiteList from "pages/dashboard/customerSiteList/page";
import Home from "pages/dashboard/homePage/page";
import HomeLayout from "pages/dashboard/homePage/layout";
import TeamAiAgent from "pages/dashboard/atom/teamAiAgent";
import NGUX from "pages/dashboard/atom/ngux";
//import LicenseAI from "pages/dashboard/license/ai/[orgid]/page";
import LicensePage from "pages/dashboard/license/page";
import Usage from "pages/dashboard/usage/page";
import CameraAIList from "pages/dashboard/cameraAIList/page";
import DatabaseLayout from "pages/dashboard/database/layout";
import Database from "pages/dashboard/database/[databaseid]/database-content";
import OpenApi from "pages/dashboard/openapi/page";
const MapLayout = lazy(() => import("pages/dashboard/map/layout"));
const Map = lazy(() => import("pages/dashboard/map/page"));
const CustomersLayout = lazy(() => import("pages/dashboard/customers/layout"));
const Customers = lazy(() => import("pages/dashboard/customers/page"));
const AutomationLayout = lazy(
  () => import("pages/dashboard/automation/layout"),
);
const Automation = lazy(() => import("pages/dashboard/automation/page"));
const BatchAutomation = lazy(
  () => import("pages/dashboard/automation/batch/page"),
);
const StreamingLayout = lazy(() => import("pages/dashboard/streaming/layout"));
const Streaming = lazy(() => import("pages/dashboard/streaming/page"));
const Playback = lazy(() => import("pages/dashboard/playback/page"));
const ContactList = lazy(() => import("pages/dashboard/contactlist/page"));
const DeviceHealth = lazy(() => import("pages/dashboard/devicehealth/page"));
const Report = lazy(() => import("pages/dashboard/analytics/reports/casePage"));
const License = lazy(() => import("pages/dashboard/license/layout"));
const PurchaseLayout = lazy(
  () => import("pages/dashboard/license/purchase/layout"),
);
const Purchase = lazy(() => import("pages/dashboard/license/purchase/page"));
const CasesLayout = lazy(() => import("pages/dashboard/cases/layout"));
const Cases = lazy(() => import("pages/dashboard/cases/page"));
const AlertsLayout = lazy(() => import("pages/dashboard/alerts/layout"));
const AlertsBasic = lazy(() => import("pages/dashboard/alerts/basic/page"));
const AlertsFocus = lazy(() => import("pages/dashboard/alerts/focus/page"));
const AudioLibrary = lazy(() => import("pages/dashboard/audioLibrary/page"));
const AudioTemplate = lazy(() => import("pages/dashboard/audioTemplate/page"));
const Schedule = lazy(() => import("pages/dashboard/schedule/page"));
const ScheduleTemplate = lazy(
  () => import("pages/dashboard/scheduleTemplate/page"),
);
const Group = lazy(() => import("pages/dashboard/group/page"));
const CameraMap = lazy(() => import("pages/dashboard/cameraMap/page"));
const AutoPilot = lazy(() => import("pages/dashboard/autopilot/page"));
const Login = lazy(() => import("pages/login"));
const Activate = lazy(() => import("pages/activate"));
const Register = lazy(() => import("pages/register"));
const PublicSharedAlerts = lazy(
  () => import("pages/shared-alerts/[alertid]/alert/page"),
);
const PublicSharedCases = lazy(
  () => import("pages/shared-cases/[caseid]/case/page"),
);

export const linkRoleAccess = [
  { path: "/dashboard", element: <Dashboard />, role: ["*"] },
  {
    path: "/dashboard/profile",
    element: <Profile />,
    role: [
      USER_ROLE.Dealer,
      USER_ROLE.Customer,
      USER_ROLE.OrgAdmin,
      USER_ROLE.SiteManager,
      USER_ROLE.DealerAdmin,
      USER_ROLE.Technician,
    ],
  },
  {
    path: "/dashboard/map",
    element: <Map />,
    LayoutElement: <MapLayout />,
    role: [
      USER_ROLE.ProjectManager,
      USER_ROLE.Customer,
      USER_ROLE.OrgAdmin,
      USER_ROLE.SiteManager,
    ],
  },
  {
    path: "/dashboard/distributor",
    element: <Distributor />,
    role: [USER_ROLE.Distributor],
  },
  {
    path: "/dashboard/admin/upload",
    element: <Upload />,
    role: [USER_ROLE.Admin],
  },
  {
    path: "/dashboard/admin/upgrade",
    element: <Upgrade />,
    role: [USER_ROLE.Admin],
  },
  {
    path: "/dashboard/admin/upgrade_camera-edge",
    element: <CameraEdgeUpgrade />,
    role: [USER_ROLE.Admin],
  },
  {
    path: "/dashboard/admin/user",
    element: <AdminUser />,
    role: [USER_ROLE.Admin],
  },
  {
    path: "/dashboard/admin/camera",
    element: <AdminCamera />,
    role: [USER_ROLE.Admin],
  },
  {
    path: "/dashboard/group",
    element: <Group />,
    role: [USER_ROLE.Dealer, USER_ROLE.Scheduler],
  },
  {
    path: "/dashboard/schedule",
    element: <Schedule />,
    role: [USER_ROLE.Scheduler, USER_ROLE.Dealer],
  },
  {
    path: "/dashboard/autopilot",
    element: <AutoPilot />,
    role: [
      USER_ROLE.Customer,
      USER_ROLE.OrgAdmin,
      USER_ROLE.SiteManager,
      USER_ROLE.Operator,
      USER_ROLE.ProjectManager,
      USER_ROLE.Dispatcher,
      USER_ROLE.Inspector,
    ],
  },
  {
    path: "/dashboard/team-ai-agent",
    element: <TeamAiAgent />,
    role: [USER_ROLE.Customer],
  },
  {
    path: "/dashboard/ngux",
    element: <NGUX />,
    role: [USER_ROLE.Customer],
  },
  {
    path: "/dashboard/template-schedule",
    element: <ScheduleTemplate />,
    role: [USER_ROLE.Scheduler, USER_ROLE.Dealer],
  },
  {
    path: "/dashboard/license/:tabname?/:id?",
    LayoutElement: <License />,
    element: <LicensePage />,
    role: [USER_ROLE.DealerAdmin, USER_ROLE.Dealer],
  },
  {
    path: "/dashboard/license/purchase/:orgid/purchase",
    element: <Purchase />,
    LayoutElement: <PurchaseLayout />,
    role: [USER_ROLE.DealerAdmin, USER_ROLE.Dealer],
  },
  {
    path: "/dashboard/audio-library",
    element: <AudioLibrary />,
    role: [USER_ROLE.DealerAdmin, USER_ROLE.Dealer, USER_ROLE.Technician],
  },
  {
    path: "/dashboard/audio-template",
    element: <AudioTemplate />,
    role: [USER_ROLE.DealerAdmin, USER_ROLE.Dealer, USER_ROLE.Technician],
  },
  {
    path: "/dashboard/contact-list",
    element: <ContactList />,
    role: [USER_ROLE.Dealer, USER_ROLE.Technician, USER_ROLE.DealerAdmin],
  },
  {
    path: "/dashboard/device-health",
    element: <DeviceHealth />,
    role: [USER_ROLE.Dealer, USER_ROLE.Technician, USER_ROLE.DealerAdmin],
  },
  {
    path: "/dashboard/dealer-org",
    element: <DealerOrg />,
    LayoutElement: <DealerOrganizationLayout />,
    role: [USER_ROLE.Dealer, USER_ROLE.DealerAdmin],
  },
  {
    path: "/dashboard/customers",
    element: <Customers />,
    LayoutElement: <CustomersLayout />,
    role: [
      USER_ROLE.Dealer,
      USER_ROLE.DealerRep,
      USER_ROLE.Technician,
      USER_ROLE.DealerAdmin,
    ],
  },
  {
    path: "/dashboard/customers/:orgid/edit",
    element: <EditCustomer />,
    LayoutElement: <CustomersLayout />,
    role: [
      USER_ROLE.Dealer,
      USER_ROLE.DealerRep,
      USER_ROLE.Technician,
      USER_ROLE.DealerAdmin,
    ],
  },
  {
    path: "/dashboard/customers/:orgid/sites",
    element: <Sites />,
    LayoutElement: <CustomersLayout />,
    role: [
      USER_ROLE.Dealer,
      USER_ROLE.DealerRep,
      USER_ROLE.Technician,
      USER_ROLE.DealerAdmin,
    ],
  },
  {
    path: "/dashboard/customers/:orgid/encoding",
    element: <Sites />,
    LayoutElement: <CustomersLayout />,
    role: [
      USER_ROLE.Dealer,
      USER_ROLE.DealerRep,
      USER_ROLE.Technician,
      USER_ROLE.DealerAdmin,
    ],
  },
  {
    path: "/dashboard/customers/:orgid/sites/:siteid/nvrs",
    element: <Nvrs />,
    LayoutElement: <CustomersLayout />,
    role: [
      USER_ROLE.Dealer,
      USER_ROLE.DealerRep,
      USER_ROLE.Technician,
      USER_ROLE.DealerAdmin,
    ],
  },
  {
    path: "/dashboard/customers/:orgid/sites/:siteid/nvrs/:nvrid/cameras",
    element: <Cameras />,
    LayoutElement: <CustomersLayout />,
    role: [
      USER_ROLE.Dealer,
      USER_ROLE.DealerRep,
      USER_ROLE.Technician,
      USER_ROLE.DealerAdmin,
    ],
  },
  {
    path: "/dashboard/customers/create",
    element: <CreateCustomer />,
    role: [
      USER_ROLE.Dealer,
      USER_ROLE.DealerRep,
      USER_ROLE.Technician,
      USER_ROLE.DealerAdmin,
    ],
  },
  {
    path: "/dashboard/customers/:orgid/sites/create",
    element: <CreateSite />,
    role: [
      USER_ROLE.Dealer,
      USER_ROLE.DealerRep,
      USER_ROLE.Technician,
      USER_ROLE.DealerAdmin,
    ],
  },
  {
    path: "/dashboard/customers/:orgid/sites/:siteid/dev-select",
    element: <CreateDeviceSelect />,
    role: [
      USER_ROLE.Dealer,
      USER_ROLE.DealerRep,
      USER_ROLE.Technician,
      USER_ROLE.DealerAdmin,
    ],
  },

  {
    path: "/dashboard/customers/:orgid/sites/:siteid/nvrs/create",
    element: <CreateNvr />,
    role: [
      USER_ROLE.Dealer,
      USER_ROLE.DealerRep,
      USER_ROLE.Technician,
      USER_ROLE.DealerAdmin,
    ],
  },
  {
    path: "/dashboard/customers/:orgid/sites/:siteid/edge-cameras/create",
    element: <CreateEdgeCamera />,
    role: [
      USER_ROLE.Dealer,
      USER_ROLE.DealerRep,
      USER_ROLE.Technician,
      USER_ROLE.DealerAdmin,
    ],
  },

  {
    path: "/dashboard/customers/:orgid/sites/:siteid/nvrs/:nvrid/cameras/create",
    element: <CreateCamera />,
    role: [
      USER_ROLE.Dealer,
      USER_ROLE.DealerRep,
      USER_ROLE.Technician,
      USER_ROLE.DealerAdmin,
    ],
  },
  {
    path: "/dashboard/customers/:orgid/sites/:siteid/nvrs/:nvrid/ip-speakers",
    element: <IpSpeakers />,
    role: [
      USER_ROLE.Dealer,
      USER_ROLE.DealerRep,
      USER_ROLE.Technician,
      USER_ROLE.DealerAdmin,
    ],
  },
  {
    path: "/dashboard/streaming",
    element: <Streaming />,
    LayoutElement: <StreamingLayout />,
    role: [
      USER_ROLE.Customer,
      USER_ROLE.OrgAdmin,
      USER_ROLE.SiteManager,
      USER_ROLE.ProjectManager,
    ],
  },
  {
    path: "/dashboard/playback/:cameraid",
    element: <Playback />,
    role: [
      USER_ROLE.Customer,
      USER_ROLE.OrgAdmin,
      USER_ROLE.SiteManager,
      USER_ROLE.ProjectManager,
    ],
  },
  {
    path: "/dashboard/alerts/basic",
    element: <AlertsBasic />,
    LayoutElement: <AlertsLayout />,
    privilege: [
      {
        name: "accessDealer",
        role: [
          USER_ROLE.Customer,
          USER_ROLE.SiteManager,
          USER_ROLE.OrgAdmin,
          USER_ROLE.ProjectManager,
        ],
      },
    ],
    role: [
      USER_ROLE.Customer,
      USER_ROLE.OrgAdmin,
      USER_ROLE.SiteManager,
      USER_ROLE.ProjectManager,
    ],
  },
  {
    path: "/dashboard/alerts/focus",
    element: <AlertsFocus />,
    LayoutElement: <AlertsLayout />,
    privilege: [
      {
        name: "accessDealer",
        role: [],
      },
    ],
    role: [USER_ROLE.Inspector, USER_ROLE.Operator],
  },
  {
    path: "/dashboard/cases",
    element: <Cases />,
    LayoutElement: <CasesLayout />,
    role: [
      USER_ROLE.Customer,
      USER_ROLE.OrgAdmin,
      USER_ROLE.SiteManager,
      USER_ROLE.Operator,
      USER_ROLE.ProjectManager,
      USER_ROLE.Dispatcher,
    ],
  },
  {
    path: "/dashboard/automation",
    element: <Automation />,
    LayoutElement: <AutomationLayout />,
    role: [
      USER_ROLE.Customer,
      USER_ROLE.OrgAdmin,
      USER_ROLE.SiteManager,
      USER_ROLE.ProjectManager,
    ],
  },
  {
    path: "/dashboard/automation/batch",
    element: <BatchAutomation />,
    role: [
      USER_ROLE.Customer,
      USER_ROLE.OrgAdmin,
      USER_ROLE.SiteManager,
      USER_ROLE.ProjectManager,
    ],
  },
  {
    path: "/dashboard/organization",
    element: <Organization />,
    LayoutElement: <OrganizationLayout />,
    role: [USER_ROLE.Customer, USER_ROLE.ProjectManager, USER_ROLE.OrgAdmin],
  },
  {
    path: "/dashboard/analytics/report",
    element: <Report />,
    role: [USER_ROLE.Customer, USER_ROLE.ProjectManager],
  },
  {
    path: "/dashboard/camera/map",
    element: <CameraMap />,
    role: [USER_ROLE.Dealer, USER_ROLE.Technician, USER_ROLE.DealerAdmin],
  },
  {
    path: "/dashboard/camera-ai-list",
    element: <CameraAIList />,
    role: [USER_ROLE.Customer],
  },
  {
    path: "/dashboard/virtual-guard",
    element: <VirtualGuardPage />,
    role: [
      USER_ROLE.ProjectManager,
      USER_ROLE.Customer,
      USER_ROLE.OrgAdmin,
      USER_ROLE.SiteManager,
    ],
  },
  {
    path: "/dashboard/virtual-guard-template",
    element: <VirtualGuardTemplate />,
    role: [
      USER_ROLE.ProjectManager,
      USER_ROLE.Customer,
      USER_ROLE.OrgAdmin,
      USER_ROLE.SiteManager,
    ],
  },
  {
    path: "/dashboard/virtual-guard-progress",
    element: <VirtualGuardProgress />,
    role: [
      USER_ROLE.ProjectManager,
      USER_ROLE.Customer,
      USER_ROLE.OrgAdmin,
      USER_ROLE.SiteManager,
    ],
  },
  {
    path: "/dashboard/customer-site-list",
    element: <CusomSiteList />,
    role: [USER_ROLE.Customer, USER_ROLE.OrgAdmin, USER_ROLE.ProjectManager],
  },
  {
    path: "/dashboard/open-api",
    element: <OpenApi />,
    role: [USER_ROLE.Dealer, USER_ROLE.DealerAdmin],
  },
  {
    path: "/dashboard/home/:tabname?",
    element: <Home />,
    LayoutElement: <HomeLayout />,
    role: [
      USER_ROLE.ProjectManager,
      USER_ROLE.Customer,
      USER_ROLE.OrgAdmin,
      USER_ROLE.SiteManager,
    ],
  },
  {
    path: "/dashboard/usage",
    element: <Usage />,
    role: [USER_ROLE.ProjectManager, USER_ROLE.Customer],
  },
  {
    path: "/dashboard/database/:databaseid?",
    LayoutElement: <DatabaseLayout />,
    element: <Database />,
    role: [USER_ROLE.Customer],
  },
  {
    path: "/login",
    element: <Login />,
    public: true,
  },
  {
    path: "/reset-password",
    element: <ResetSendEmail />,
    public: true,
  },
  {
    path: "/reset-activate",
    element: <ResetActivate />,
    public: true,
  },
  {
    path: "/register",
    element: <Register />,
    public: true,
  },
  {
    path: "/activate",
    element: <Activate />,
    public: true,
  },
  {
    path: "/shared-alerts/:alertid",
    element: <PublicSharedAlerts />,
    public: true,
  },
  {
    path: "/shared-cases/:caseId",
    element: <PublicSharedCases />,
    public: true,
  },
  {
    path: "/shared-cases/:caseId",
    element: <PublicSharedCases />,
    public: true,
  },
  {
    path: "/",
    redirect: "/login",
    public: true,
    privilege: [
      {
        name: "dealerIcon",
        role: [
          USER_ROLE.Customer,
          USER_ROLE.SiteManager,
          USER_ROLE.OrgAdmin,
          USER_ROLE.ProjectManager,
        ],
      },
      {
        name: "caseDealer",
        role: [
          USER_ROLE.Dispatcher,
          USER_ROLE.Inspector,
          USER_ROLE.ProjectManager,
          USER_ROLE.Technician,
          USER_ROLE.Operator,
        ],
      },
    ],
  },
  {
    path: "/sso",
    element: <SSO />,
    public: true,
  },
  //   404page
  {
    path: "*",
    redirect: "/login",
    public: true,
  },
];
